var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06207 6.87812C1.24817 7.06563 1.5009 7.17189 1.76508 7.17368C2.02926 7.17547 2.28342 7.07264 2.47204 6.88767L6.08593 3.37206L9.60187 6.93595C9.78797 7.12346 10.0407 7.22972 10.3049 7.2315C10.5691 7.23329 10.8232 7.13047 11.0118 6.94549C11.1062 6.85317 11.1813 6.74307 11.2329 6.62156C11.2845 6.50005 11.3115 6.36952 11.3124 6.23751C11.3133 6.1055 11.2881 5.97462 11.2381 5.85242C11.1882 5.73022 11.1146 5.61912 11.0215 5.52553L6.81026 1.25691C6.71794 1.16256 6.60784 1.08742 6.48633 1.03582C6.36482 0.98423 6.23429 0.957208 6.10228 0.956314C5.97027 0.95542 5.83939 0.980673 5.71719 1.03062C5.59499 1.08056 5.48389 1.1542 5.3903 1.2473L1.07169 5.45815C0.97733 5.55048 0.902188 5.66057 0.850596 5.78209C0.799003 5.9036 0.771979 6.03412 0.771085 6.16613C0.770191 6.29814 0.795445 6.42902 0.845387 6.55122C0.89533 6.67342 0.968974 6.78452 1.06207 6.87812Z",
    fill: "#075244"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.e0a47c71b58e5b763ed62a29385c8675.svg";
export { ForwardRef as ReactComponent };